import {
  gatewayPublicApiKey,
  COASTLINE_GATEWAY_URL,
  COASTLINE_SERVICE_URL,
  schedulingApiUrl,
  serverUrl,
} from "../config"
import { logError } from "./errors"

interface ResponseOptions {
  format?: "raw" | "json"
  silenceErrors?: boolean
}

const DOMAINS = [
  serverUrl,
  schedulingApiUrl,
  COASTLINE_SERVICE_URL,
  COASTLINE_GATEWAY_URL,
]

const handleLogging = (url: string, error: any, eventId: string | null) => {
  if (DOMAINS.find((domain) => url.includes(domain))) {
    logError(error, { url, eventId })
  }
}

export const addGatewayKeyParam = (absUrl: string) => {
  let keySuffix = ""

  if (process.env.REACT_APP_ENV === "production") {
    const sep = absUrl.includes("?") ? "&" : "?"
    keySuffix = `${sep}key=${gatewayPublicApiKey}`
  }

  const updatedUrl = `${absUrl}${keySuffix}`

  return updatedUrl
}

export const makeApiCall = (
  absUrl: string,
  fetchInfo: RequestInit,
  options?: ResponseOptions,
) => {
  const updatedUrl = addGatewayKeyParam(absUrl)

  return fetch(`${updatedUrl}`, fetchInfo)
    .then((response) => {
      if (options?.format === "raw") {
        return response
      }

      if (response.ok) {
        return response.json()
      }
      return response.json().then((data) => {
        let errorMsg
        if ("errors" in data) {
          // for all errors returned from validationResult
          errorMsg = data.errors
            .map(
              (err: { msg: string; value?: string }) =>
                `${err.msg}, value: ${err.value}.`,
            )
            .join(", ")
        } else {
          errorMsg = data.message
        }
        throw new Error(
          `Error (${response.status}) making api call to ${absUrl} : ${errorMsg}`,
          { cause: data.sentryEventId || null },
        )
      })
    })
    .catch((error) => {
      if (error.name === "AbortError" || !!options?.silenceErrors) {
        throw error
      }

      handleLogging(absUrl, error, error.cause || null)
      throw error
    })
}
